import {
  getVerificationStatus,
  GetVerificationStatusType,
  uploadVerificationDocument,
  UploadVerificationDocumentResponseType,
  verificationBusiness,
  VerificationBusinessPayloadType,
  verificationEntrepreneur,
  VerificationEntrepreneurPayloadType,
  verificationPerson,
  VerificationPersonPayloadType,
  VerificationSessionResponseType,
} from '@/lib/api/methods';
import { useRequest } from 'ahooks';
import { createContext, JSX, useContext, useState } from 'react';
import { NotificationContext } from './notificationContext';
import { SocketContext } from './socketContext';
import { AccountContext } from './accountContext';

export type ContextProps = {
  isKycModalOpen: boolean;
  kycModalIsOnAction: boolean;
  isVerificationPersonLoading: boolean;
  isLoadingVerificationStatus: boolean;
  isVerificationBusinessLoading: boolean;
  isUploadVerificationImgLoading: boolean;
  isVerificationEntrepreneurLoading: boolean;
  verificationStatus: GetVerificationStatusType;

  refreshVerificationStatus: () => void;

  onVerificationBusiness: (
    data: VerificationBusinessPayloadType
  ) => Promise<VerificationSessionResponseType>;
  onVerificationEntrepreneur: (
    data: VerificationEntrepreneurPayloadType
  ) => Promise<VerificationSessionResponseType>;
  onVerificationPerson: (
    data: VerificationPersonPayloadType
  ) => Promise<VerificationSessionResponseType>;

  changeIsOpenedKycModal: (isOpen: boolean, isOnAction?: boolean) => void;
  uploadVerificationImg: (
    formData: FormData
  ) => Promise<UploadVerificationDocumentResponseType>;
};

export const VerificationContext = createContext({} as ContextProps);

export const VerificationProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const { openNotificationWithIcon } = useContext(NotificationContext);
  const { isAuthorized, accountData } = useContext(AccountContext);
  const [isKycModalOpen, setIsKycModalOpen] = useState(false);
  const [kycModalIsOnAction, setKycModalIsOnAction] = useState(false);
  const changeIsOpenedKycModal = (isOpen: boolean, isOnAction = false) => {
    setIsKycModalOpen(isOpen);
    setKycModalIsOnAction(isOnAction);
  };

  const {
    data: verificationStatus,
    loading: isLoadingVerificationStatus,
    refreshAsync: refreshVerificationStatus,
  } = useRequest(
    () => {
      return getVerificationStatus(accountData?.country);
    },
    {
      ready: isAuthorized && !!accountData?.country,
      onError: (error: any) => {
        if (error.status !== 404) {
          if (error.response.message) {
            console.error('error', error.response.message);
          } else {
            console.error('error', error.message);
          }
        }
      },
    }
  );

  const {
    loading: isUploadVerificationImgLoading,
    runAsync: uploadVerificationImg,
  } = useRequest(
    (formData: FormData) => {
      return uploadVerificationDocument(formData);
    },
    {
      manual: true,
      onError: (error: any) => {
        if (error.response.message) {
          openNotificationWithIcon('error', error.response.message);
        } else {
          openNotificationWithIcon('error', error.message);
        }
      },
    }
  );

  const {
    loading: isVerificationPersonLoading,
    runAsync: onVerificationPerson,
  } = useRequest(
    (data: VerificationPersonPayloadType) => verificationPerson(data),
    {
      manual: true,
      // onError: (error: any) => {
      //   if (error.response.message) {
      //     openNotificationWithIcon('error', error.response.message);
      //   } else {
      //     openNotificationWithIcon('error', error.message);
      //   }
      // },
    }
  );
  const {
    loading: isVerificationEntrepreneurLoading,
    runAsync: onVerificationEntrepreneur,
  } = useRequest(
    (data: VerificationEntrepreneurPayloadType) =>
      verificationEntrepreneur(data),
    {
      manual: true,
      // onError: (error: any) => {
      //   if (error.response.message) {
      //     openNotificationWithIcon('error', error.response.message);
      //   } else {
      //     openNotificationWithIcon('error', error.message);
      //   }
      // },
    }
  );
  const {
    loading: isVerificationBusinessLoading,
    runAsync: onVerificationBusiness,
  } = useRequest(
    (data: VerificationBusinessPayloadType) => verificationBusiness(data),
    {
      manual: true,
      // onError: (error: any) => {
      //   if (error.response.message) {
      //     openNotificationWithIcon('error', error.response.message);
      //   } else {
      //     openNotificationWithIcon('error', error.message);
      //   }
      // },
    }
  );

  return (
    <VerificationContext.Provider
      value={{
        onVerificationPerson,
        uploadVerificationImg,
        changeIsOpenedKycModal,
        onVerificationBusiness,
        refreshVerificationStatus,
        onVerificationEntrepreneur,
        isKycModalOpen,
        kycModalIsOnAction,
        verificationStatus,
        isLoadingVerificationStatus,
        isVerificationPersonLoading,
        isVerificationBusinessLoading,
        isUploadVerificationImgLoading,
        isVerificationEntrepreneurLoading,
      }}
    >
      {children}
    </VerificationContext.Provider>
  );
};
